import React from 'react';
import { Link } from 'react-router-dom';

const OrderSuccess = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>Order Confirmed!</h1>
        </div>
      </section>

      <section className="bg-white pt-2xl pb-2xl">
        <div className="container container-narrow" style={{ textAlign: 'center' }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: '#9caf88',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 2rem',
            fontSize: '2.5rem'
          }}>
            ✓
          </div>

          <h2 style={{ marginBottom: '1rem' }}>Thank You for Your Order!</h2>

          <p style={{ fontSize: '1.125rem', color: '#666', marginBottom: '2rem' }}>
            Your payment was successful. We've received your order and will be in touch
            within 24 hours to confirm details and discuss your event.
          </p>

          <div style={{
            background: '#faf8f5',
            padding: '2rem',
            borderRadius: '12px',
            marginBottom: '2rem',
            textAlign: 'left'
          }}>
            <h4 style={{ marginBottom: '1rem' }}>What Happens Next?</h4>
            <ol style={{ paddingLeft: '1.25rem', color: '#666' }}>
              <li style={{ marginBottom: '0.5rem' }}>You'll receive a confirmation email from Stripe with your receipt</li>
              <li style={{ marginBottom: '0.5rem' }}>Our team will review your order details within 24 hours</li>
              <li style={{ marginBottom: '0.5rem' }}>We'll reach out to confirm your event date and any customizations</li>
              <li>Your party box will ship 7-10 days before your event</li>
            </ol>
          </div>

          <p style={{ color: '#666', marginBottom: '2rem' }}>
            Questions? Contact us at{' '}
            <a href="mailto:hello@agoldenaffair.com" style={{ color: '#c4a574' }}>
              hello@agoldenaffair.com
            </a>
          </p>

          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn btn-primary">
              Back to Home
            </Link>
            <Link to="/party-boxes" className="btn btn-secondary">
              Browse More Boxes
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default OrderSuccess;
